import { Group, PinInput as ChakraPinInput } from "@chakra-ui/react-v3";
import * as React from "react";

import type { TestingAttributes } from "types/dom";

export interface PinInputProps
  extends ChakraPinInput.RootProps, TestingAttributes {
  rootRef?: React.RefObject<HTMLDivElement | null>;
  count?: number;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  attached?: boolean;
}

export const PinInput = React.forwardRef<HTMLInputElement, PinInputProps>(
  function PinInput(props, ref) {
    const {
      count = 4,
      inputProps,
      rootRef,
      attached,
      "data-cy": dataCy,
      ...rest
    } = props;

    return (
      <ChakraPinInput.Root ref={rootRef} count={count} {...rest}>
        <ChakraPinInput.HiddenInput ref={ref} {...inputProps} />
        <ChakraPinInput.Control data-cy={dataCy}>
          <Group attached={attached}>
            {Array.from({ length: count }).map((_, index) => (
              <ChakraPinInput.Input key={index} index={index} />
            ))}
          </Group>
        </ChakraPinInput.Control>
      </ChakraPinInput.Root>
    );
  },
);
